import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, MenuItem, Select, makeStyles } from "@material-ui/core";
import * as miscAction from "../../actions/miscAction";
import { connect } from "react-redux";

const DMModelSelect = ({miscState, modelState, onModelSelected}) => {
    const useStyles = makeStyles((theme) => ({
        formControl: {
            minWidth: 222,
            '& .MuiSelect-root' : {
                padding: '10px'
            }
          },
    }));

    const classes = useStyles();

    const [selectedModel, setSelectedModel] = useState(miscState.selectedModel);   

    useEffect(() =>{
        if(miscState.selectedModel) {
            setSelectedModel(miscState.selectedModel);
        }
    }, [miscState.selectedModel])

    const handleChange = (e) => {
      let [t=null] =  modelState?.models?.data?.filter(x=> x.modelId === e.target.value)

      onModelSelected({id: e.target.value, name: t?.modelName || ""})
    }

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel id="model-label-id">Model ID</InputLabel>
      <Select
        labelId="model-label-id"
        id="model-id"
        label={"Model ID"}
        variant="outlined"
        value={selectedModel}
        className={classes.modelid}
        onChange={handleChange}
      >
        {modelState.models.data.map((m) => {
          return <MenuItem className="model-value" value={m.modelId}>{m.modelName}</MenuItem>;
        })}
      </Select>
    </FormControl>
  );
};

const mapStateToProps = (state) => ({
  miscState: state.misc,
  modelState: state.model
});

const mapDispatchToProps = (dispatch) => {
  return {
    onModelSelected : (modelId) => dispatch(miscAction.onModelSelected(modelId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DMModelSelect);
